import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { Subject } from 'rxjs'
import { PublicTimelineItem, PublicEventInfo } from 'globals/store/public.model'
import { TimelineItemComponent } from './../timeline/timeline-item.component';
import { CommonModule, DatePipe } from '@angular/common';
import { TimelineStartPipe } from 'src/app/services/pipes/timelineStart.pipe';


// one publish timeline item to rule them all.
@Component({
    selector: 'publish-timeline-item',
    template: `
<timeline-item
  #timelineItem
  *ngIf="{ start: !!first ? session.start : { session: session, priorSession: priorSession } | timelineStart } as vars"
  [start]="vars.start" 
  [hideDot]="!vars.start && !last"
  [timezoneAbbr]="session.timezoneAbbr"
  [epoch]="session.epoch"
  [performerRoleIds]="session.performerRoleIds"
  [performerRoles]="joiEvent?.performerRoles || {}"
  [userSelectedTimezone]="userSelectedTimezone"
  [end]="session.end"
  [collapsible]="true"
  [startingCollapseState]="startingCollapseState"
  [hideTimeLine]="hideTimeLine"
  [duration]="session.duration"
  [printDate]="(session.displayDate ? session.displayDate :  session.session_date == session.on_day ? 'Day '+session.on_day : (session.session_date | date:'EEEE d LLLL y'))"
  [militaryTime]="militaryTime"
  [hideTimeZone]="hideTimeZone"
  [first]="first" 
  [last]="last" 
  [title]="session.title" 
  [hidePerformersHeading]="true"
  [condensedPerformers]="false" 
  [description]="session.description" 
  [labelMap]="joiEvent.session_labels" 
  [labelMaps]="{ performer_labels: joiEvent.performer_labels, sponsor_labels: joiEvent.sponsor_labels }"
  [labelIds]="session.labels" 
  [performers]="joiEvent.performers" 
  [performerIds]="session.performerIds"
  [publicLinks]="session.publicLinks" 
  [sponsors]="joiEvent.sponsors"
  [sponsorIds]="session.sponsorIds"
  [sponsorTypes]="joiEvent.sponsorTypes"
  [sponsorsCustomTitle]="sponsorsCustomTitle"
  [programLine]="programText"
  [checked]="checked"
  [checking]="checking"
  (onCheck)="onCheck.emit()">
</timeline-item>
  `,
    styles: [`
h3.group_date { text-align: center; padding: 10px 0 20px; }
h3.group_date.extraSpacing { margin-bottom: 20px; }
  `],
    standalone: true,
    imports: [TimelineItemComponent, CommonModule, TimelineStartPipe, DatePipe],
})
export class PublishTimelineItemComponent implements OnInit  {

  @Input() session: PublicTimelineItem
  @Input() priorSession: PublicTimelineItem
  @Input() latterSession: PublicTimelineItem
  @Input() joiEvent: PublicEventInfo;
  @Input() first = false
  @Input() last = false
  @Input() userSelectedTimezone: any;
  @Input() startingCollapseState: 'expand' | 'collapse' = 'collapse'
  @Input() programText: string
  @Input() hideTimeLine = false
  @Input() toggleSubject: Subject<boolean>
  @Input() militaryTime = true
  @Input() hideTimeZone = false
  @Input() checking: boolean
  @Input() checked: boolean
  @Input() sponsorsCustomTitle?: string
  @Output() onCheck: EventEmitter<void> = new EventEmitter()

  @ViewChild('timelineItem') timelineItem: TimelineItemComponent

  ngOnInit() {
    if (this.toggleSubject) this.toggleSubject.subscribe({ 
      next: (expand) => expand ? this.timelineItem.expand() : this.timelineItem.collapse() 
    })
  }
}
